export const getScopeOptions = (isCreateMode?: boolean) => {
  const options = [
    "Records",
    "Contacts"
  ].sort();

  return isCreateMode ? ["Select Accela scope", ...options] : options;
};